import { memo, ReactNode } from "react";
import Footer from "../common/Footer/Footer";
import classes from "./Layout.module.scss";
import Header from "../common/Header/Header";
import { useMediaQuery } from "react-responsive";
import MobileHeader from "../common/MobileHeader/MobileHeader";
import { When } from "@/components/common/When";
import { everyTrue } from "@/helper/helper";
import { diffMobileHeader } from "@/constant";
import { usePathname } from "next/navigation";
type Props = {
  children: ReactNode;
  nav?: boolean;
  footer?: boolean;
  shadow?: string;
  title?: {
    vcard: string;
    socialMedia: string;
    pdf: string;
  };
  footerTitle?: string;
};
const Layout = ({
  children,
  nav,
  footer,
  shadow,
  title,
  footerTitle
}: Props) => {
  const pathname = usePathname();
  const isMobile = useMediaQuery({
    maxWidth: 1024
  });
  const showMobileHeader = everyTrue(isMobile, diffMobileHeader.some(diff => diff === pathname));
  return <div className="layout" data-sentry-component="Layout" data-sentry-source-file="Layout.tsx">
      {nav && <>
          <Header shadow={shadow} />
          <MobileHeader />
        </>}
      <div className={classes.Main}>{children}</div>
      <When condition={everyTrue(footer, !showMobileHeader)} data-sentry-element="When" data-sentry-source-file="Layout.tsx">
        <Footer title={title} footerTitle={footerTitle} data-sentry-element="Footer" data-sentry-source-file="Layout.tsx" />
      </When>
    </div>;
};
export default memo(Layout);